export default "__VITE_ASSET__502da548__";